// extracted by mini-css-extract-plugin
module.exports = {"heading":"SignupActivity-heading-c7b42f007413b6800a73d57cdf37a405","chart":"SignupActivity-chart-e4f5ec5d33a13acca203bf6e0410d86b"};